export default __webpack_public_path__ + "92c45fea047ebde1465aa4f2df839967.webp";